var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Cert',{on:{"complete":_vm.nextStep}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topTitle"},[_c('div',{staticClass:"title"},[_vm._v("전북현대"),_c('br'),_vm._v("회원가입 본인인증")]),_c('div',{staticClass:"subTitle"},[_vm._v("전북현대모터스에프씨 웹사이트 가입을 위해서 본인인증 절차가 필요합니다."),_c('br'),_vm._v("아래 본인인증 서비스 중 하나를 선택하세요.")])])
}]

export { render, staticRenderFns }